import React from "react"
import { NavLink } from "react-router-dom"

import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle
} from "reactstrap"
import { Power, User } from "react-feather"

import { history } from "../../../history"
import AuthService from '../../../services/AuthService'

const UserDropdown = props => {

  let { user_public_id }  = props.authUser
  return (
    <DropdownMenu right style={{  marginTop: '20px' }}>
      <NavLink to={"/user/" + user_public_id} exact>
        <DropdownItem style={{ }}>
          <User size={14} className="mr-50" />
          <span className="align-middle">Profile</span>
        </DropdownItem>
      </NavLink>
      <NavLink to={"/user/" + user_public_id + "/change-password"} exact>
        <DropdownItem style={{ width: '300px' }}>
          <User size={14} className="mr-50" />
          <span className="align-middle">Change Password</span>
        </DropdownItem>
      </NavLink>
      <DropdownItem divider />
      <DropdownItem
        tag="a"
        href="#"
        onClick={e => {
          AuthService.logOut();
          // history.push("/login");
        }}
      >
        <Power size={14} className="mr-50" />
        <span className="align-middle">Log Out</span>
      </DropdownItem>
    </DropdownMenu>
  )
}

const NavbarUser = (props) => {

  let { first_name, last_name} = props.authUser
  return (
    <ul className="nav navbar-nav navbar-nav-user float-right">
      <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
        <DropdownToggle tag="a" className="nav-link dropdown-user-link">
          <div className="user-nav d-sm-flex d-none">
            { props.currentOrgID != undefined || props.currentOrgID == "" && <span className="user-name text-capitalize text-white text-bold-600">
              {props.currentOrg}
            </span> }
            <span className="user-status text-white" style={{marginTop: '5px'}}>{first_name + ' ' + last_name }</span>
          </div>
          <span data-tour="user">
            {/*<img*/}
            {/*  src={this.props.userImg}*/}
            {/*  className="round"*/}
            {/*  height="40"*/}
            {/*  width="40"*/}
            {/*  alt="avatar"*/}
            {/*/>*/}
            <User height="40" width="40" color={'#19d1dd'} />
          </span>
        </DropdownToggle>
        <UserDropdown {...props} />
      </UncontrolledDropdown>
    </ul>
  )
}

export default NavbarUser
